import React from "react";
import { useI18next } from "gatsby-plugin-react-i18next";
import PT from "prop-types";
import styled from "styled-components";
import { graphql } from "gatsby";

import {
    BlockBanner,
    BlockAboutSmall,
    // BlockRegistration,
    BlockAboutBanner,
    BlockAbout,
    BlockIdeas,
    // BlockTest,
    BlockVideos,
} from "~/src/components/blocks";

import { Layout, Meta } from "~/src/components";

const IndexPage = ({ data }) => {
    const { language } = useI18next();

    let meta_title =
        "MediaJasa — расскажи о том, что тебя волнует на весь Кыргызстан.";
    let meta_desc =
        "Зарегистрируйся и научись создавать и продвигать контент в интернете.";
    if (language === "kg") {
        meta_title = "MediaJasa — бүтүндөй Кыргызстанга идеяңызды билдириңиз.";
        meta_desc =
            "Катталып, интернетте контент жаратууну жана аны жайылтууну үйрөнүңүз.";
    }

    return (
        <Layout>
            <Meta title={meta_title} description={meta_desc} />
            <SBlock>
                <BlockBanner />
            </SBlock>
            <SBlock>
                <BlockAboutSmall />
            </SBlock>
            {/* <SBlock>
                <i id="BlockRegistration" />
                <BlockRegistration />
            </SBlock> */}
            <SBlock>
                <i id="BlockAbout" />
                <BlockAboutBanner />
            </SBlock>
            <SBlock>
                <BlockAbout />
            </SBlock>
            <SBlock>
                <i id="BlockIdeas" />
                <BlockIdeas ideas_ru={data.ideas_ru} ideas_kg={data.ideas_kg} />
            </SBlock>
            {/* <SBlock>
                <i id="BlockTest" />
                <BlockTest />
            </SBlock> */}
            <SBlock>
                <i id="BlockVideos" />
                <BlockVideos />
            </SBlock>
        </Layout>
    );
};

IndexPage.propTypes = {
    data: PT.object,
};

const SBlock = styled.section``;

export const query = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        ideas_kg: allFile(
            sort: { order: ASC, fields: name }
            filter: {
                name: { regex: "/(_kg)/" }
                sourceInstanceName: { eq: "images_ideas" }
            }
        ) {
            edges {
                node {
                    childImageSharp {
                        gatsbyImageData(
                            layout: FULL_WIDTH
                            placeholder: BLURRED
                        )
                    }
                }
            }
        }
        ideas_ru: allFile(
            sort: { order: ASC, fields: name }
            filter: {
                name: { regex: "/(_ru)/" }
                sourceInstanceName: { eq: "images_ideas" }
            }
        ) {
            edges {
                node {
                    childImageSharp {
                        gatsbyImageData(
                            layout: FULL_WIDTH
                            placeholder: BLURRED
                        )
                    }
                }
            }
        }
    }
`;

export default IndexPage;
